var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Exp-header'),_c('div',{staticClass:"main"},[_c('router-view')],1),_c('div',{staticClass:"footer"},[_vm._v(" ©copyright 华侨大学建筑学院虚拟仿真实验申报管理平台 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }